import api from "../utils/axios";

export async function getPaymentGateways() {

    const response = await api.get(

        `/payment-gateways`

    );

    return response.data.gateways;
}